// Showcase Metric Component
// Custom web component for displaying project metrics

import type { MetricDisplay, TranslatedText } from "./showcase-config.ts";

class ShowcaseMetric extends HTMLElement {
  private config: MetricDisplay | null = null;

  connectedCallback() {
    this.render();
  }

  setConfig(config: MetricDisplay) {
    this.config = config;
    this.render();
  }

  private getCurrentLang(): string {
    if (typeof globalThis.getInitialLang === "function") {
      return globalThis.getInitialLang();
    }
    return "en";
  }

  private translate(text: TranslatedText): string {
    const lang = this.getCurrentLang();
    return text[lang as keyof TranslatedText] || text.en;
  }

  private render() {
    if (!this.config) return;

    this.innerHTML = `
      <div class="bg-gradient-to-br ${this.config.bgGradient} p-8 flex items-center justify-center h-full">
        <div class="text-center">
          <div class="text-5xl font-bold ${this.config.colorClass} mb-2">${this.config.value}</div>
          <p class="text-slate-600 font-medium">
            <span data-en="${this.config.label.en}" data-lv="${this.config.label.lv}" data-it="${this.config.label.it}">
              ${this.translate(this.config.label)}
            </span>
          </p>
          <p class="text-sm text-slate-500 mt-4">
            <span data-en="${this.config.sublabel.en}" data-lv="${this.config.sublabel.lv}" data-it="${this.config.sublabel.it}">
              ${this.translate(this.config.sublabel)}
            </span>
          </p>
        </div>
      </div>
    `;
  }
}

customElements.define("showcase-metric", ShowcaseMetric);

export { ShowcaseMetric };

